import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Button, Alert } from "react-bootstrap";
import { API_BASE_URL } from "../Config";

function getCsrfToken() {
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === 'csrftoken') {
      return value;
    }
  }
  console.log("CSRF Token não encontrado");
  return null;
}

function UpdateClientScreen() {
  const [formData, setFormData] = useState({
    name: "",
    lastname: "",
    additional_address: "",
    email: "",
    postal_code: "",
    address: "",
    number: "",
    city: "",
    country: "",
    phone: "",
    password: "",
  });
  const [showError, setShowError] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const fetchClientData = async () => {
      const clientId = localStorage.getItem("clientId"); // Recupera o ID do cliente do localStorage
      const csrfToken = getCsrfToken(); // Obter o token CSRF
      console.log("CSRF Token:", csrfToken);
      console.log("Client ID recuperado do localStorage:", clientId); // Verifique se o ID do cliente está sendo recuperado
  
      if (clientId && csrfToken) {
        try {
          const response = await fetch(`${API_BASE_URL}/api/update_client/${clientId}/`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'X-CSRFToken': csrfToken, // Adicionar o token CSRF no cabeçalho
            },
            credentials: 'include' // Incluir credenciais (cookies)
          });
  
          console.log("Fetching data from: ", `${API_BASE_URL}/api/update_client/${clientId}/`);
          if (!response.ok) {
            throw new Error("Erro ao buscar dados do cliente.");
          }
          const data = await response.json();
          console.log("Client data fetched: ", data);
          setFormData({
            name: data.name,
            lastname: data.lastname,
            additional_address: data.additional_address,
            email: data.email,
            postal_code: data.postal_code,
            address: data.address,
            number: data.number,
            city: data.city,
            country: data.country,
            phone: data.phone,
          });
        } catch (error) {
          console.error("Erro ao buscar dados do cliente:", error);
          setShowError(true);
          setErrorMessage("Erro ao buscar dados do cliente.");
        }
      } else {
        setShowError(true);
        setErrorMessage("ID do cliente ou CSRF Token não encontrado.");
      }
    };
  
    fetchClientData();
  }, []);
  

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setShowError(false);
    setShowSuccess(false);

    const clientId = localStorage.getItem("clientId");
    const csrfToken = getCsrfToken();

    if (!csrfToken) {
      setShowError(true);
      setErrorMessage("CSRF Token não encontrado nos cookies!");
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/api/update_client/${clientId}/`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': csrfToken,  // Inclua o token CSRF
        },
        credentials: 'include', // Incluir credenciais (cookies)
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setShowSuccess(true);
      } else {
        const data = await response.json();
        setErrorMessage(data.message || "Erro ao atualizar os dados. Verifique os dados e tente novamente.");
        setShowError(true);
      }
    } catch (error) {
      console.error("Erro ao atualizar os dados:", error);
      setErrorMessage("Erro ao atualizar os dados. Verifique os dados e tente novamente.");
      setShowError(true);
    }
  };

  return (
    <Container className="pt-4">
      <Row>
        <Col sm={12} className="m-auto">
          <h3 className="pb-md-1">Alterar Dados</h3>
          {showError && (
            <Alert variant="danger">
              {errorMessage}
            </Alert>
          )}
          {showSuccess && (
            <Alert variant="success">
              Dados atualizados com sucesso!
            </Alert>
          )}
        </Col>
      </Row>

      {!showSuccess && (
        <Form onSubmit={handleSubmit} className="p-4 mt-4 mt-md-0 m-auto" style={{ backgroundColor: "#fff", border: "thin solid #eee" }}>
            <Row>
              <Col md={6} sm={12}>
                <Form.Group className="mb-3" controlId="formName">
                  <Form.Label>Nome</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    style={{
                      backgroundColor: "#ffffff",
                      border: "thin solid #eee",
                    }}
                    required
                  />
                </Form.Group>
              </Col>

              <Col md={6} sm={12}>
                <Form.Group className="mb-3" controlId="formLastname">
                  <Form.Label>Sobrenome</Form.Label>
                  <Form.Control
                    type="text"
                    name="lastname"
                    value={formData.lastname}
                    onChange={handleChange}
                    style={{
                      backgroundColor: "#ffffff",
                      border: "thin solid #eee",
                    }}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6} sm={12}>
                <Form.Group className="mb-3" controlId="formAdditionalAddress">
                  <Form.Label>Endereço Adicional</Form.Label>
                  <Form.Control
                    type="text"
                    name="additional_address"
                    value={formData.additional_address}
                    onChange={handleChange}
                    style={{
                      backgroundColor: "#ffffff",
                      border: "thin solid #eee",
                    }}
                  />
                </Form.Group>
              </Col>

              <Col md={6} sm={12}>
                <Form.Group className="mb-3" controlId="formEmail">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    disabled
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6} sm={12}>
                <Form.Group className="mb-3" controlId="formPostalCode">
                  <Form.Label>CEP</Form.Label>
                  <Form.Control
                    type="text"
                    name="postal_code"
                    value={formData.postal_code}
                    onChange={handleChange}
                    style={{
                      backgroundColor: "#ffffff",
                      border: "thin solid #eee",
                    }}
                    required
                  />
                </Form.Group>
              </Col>

              <Col md={6} sm={12}>
                <Form.Group className="mb-3" controlId="formAddress">
                  <Form.Label>Endereço</Form.Label>
                  <Form.Control
                    type="text"
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    style={{
                      backgroundColor: "#ffffff",
                      border: "thin solid #eee",
                    }}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6} sm={12}>
                <Form.Group className="mb-3" controlId="formNumber">
                  <Form.Label>Número</Form.Label>
                  <Form.Control
                    type="text"
                    name="number"
                    value={formData.number}
                    onChange={handleChange}
                    style={{
                      backgroundColor: "#ffffff",
                      border: "thin solid #eee",
                    }}
                    required
                  />
                </Form.Group>
              </Col>

              <Col md={6} sm={12}>
                <Form.Group className="mb-3" controlId="formCity">
                  <Form.Label>Cidade</Form.Label>
                  <Form.Control
                    type="text"
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                    style={{
                      backgroundColor: "#ffffff",
                      border: "thin solid #eee",
                    }}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6} sm={12}>
                <Form.Group className="mb-3" controlId="formCountry">
                  <Form.Label>País</Form.Label>
                  <Form.Control
                    type="text"
                    name="country"
                    value={formData.country}
                    onChange={handleChange}

                    required
                    disabled
                  />
                </Form.Group>
              </Col>

              <Col md={6} sm={12}>
                <Form.Group className="mb-3" controlId="formPhone">
                  <Form.Label>Telefone</Form.Label>
                  <Form.Control
                    type="text"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    style={{
                      backgroundColor: "#ffffff",
                      border: "thin solid #eee",
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>



            <Row>
              <Col sm={12}>
                <Button
                  variant="primary"
                  type="submit"
                  className="mb-3"
                  title="Atualizar"
                >
                  Atualizar
                </Button>
              </Col>
            </Row>

        </Form>
      )}
    </Container>
  );
}

export default UpdateClientScreen;